<template>
  <header id="header" :class="{ 'is-scrolled': scrolled }">
    <div class="header-inner ns-wrap">
      <router-link to="/" class="brand" @click.native="navClick(0, '首页')">
        <img src="@/assets/img/logo_black.png" alt="诺思技术">
        <div class="brand-copy">
          <strong>诺思技术</strong>
          <span>AI · INTELLIGENCE</span>
        </div>
      </router-link>

      <nav class="desktop-nav hidden-xs">
        <ul>
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="{ active: index == navIndex }"
            @click="navClick(index, item.name)"
          >
            <router-link :to="item.path">{{ item.name }}</router-link>
          </li>
        </ul>
      </nav>

      <div class="header-actions hidden-xs">
        <a class="header-phone" :href="'tel:' + config.phone">{{ config.phone }}</a>
        <router-link class="ns-btn header-cta" to="/contactus" @click.native="navClick(6, '联系我们')">联系我们</router-link>
      </div>

      <button class="menu-btn visible-xs" type="button" @click="menuOpen = !menuOpen">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <div class="mobile-nav visible-xs" v-show="menuOpen">
      <router-link
        v-for="(item, index) in navList"
        :key="index"
        :to="item.path"
        :class="{ active: index == navIndex }"
        @click.native="navClick(index, item.name); menuOpen = false"
      >
        {{ item.name }}
      </router-link>
    </div>
  </header>
</template>

<script>
import config from "@/config";
export default {
  name: "Header",
  data() {
    return {
      config: config,
      scrolled: false,
      menuOpen: false,
      navIndex: sessionStorage.getItem("navIndex") ? sessionStorage.getItem("navIndex") : 0,
      navList: [
        { name: "首页", path: "/" },
        { name: "软件产品", path: "/software" },
        { name: "相关服务", path: "/service" },
        { name: "新闻动态", path: "/newsinformation" },
        { name: "公司介绍", path: "/companyintroduction" },
        { name: "工作机会", path: "/jobchance" },
        { name: "联系我们", path: "/contactus" }
      ]
    };
  },
  mounted() {
    this.onScroll();
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
    },
    onScroll() {
      this.scrolled = window.scrollY > 12;
    }
  }
};
</script>

<style scoped>
#header {
  position: sticky;
  top: 0;
  z-index: 1000;
  height: var(--ns-header-h);
  background: rgba(245, 248, 253, 0.72);
  border-bottom: 1px solid transparent;
  backdrop-filter: blur(18px);
  transition: background 0.3s ease, border-color 0.3s ease;
}

#header.is-scrolled {
  background: rgba(255, 255, 255, 0.92);
  border-bottom-color: var(--ns-border);
}

.header-inner {
  height: var(--ns-header-h);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--ns-heading);
}

.brand img {
  width: 42px;
  height: 42px;
  object-fit: contain;
}

.brand-copy {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.brand-copy strong {
  font-size: 16px;
  letter-spacing: 0.08em;
}

.brand-copy span {
  color: var(--ns-cyan);
  font-size: 10px;
  letter-spacing: 0.22em;
}

.desktop-nav ul {
  display: flex;
  gap: 8px;
  margin: 0;
}

.desktop-nav a {
  display: block;
  padding: 8px 12px;
  color: var(--ns-muted);
  font-size: 14px;
  letter-spacing: 0.04em;
}

.desktop-nav li.active a,
.desktop-nav a:hover {
  color: var(--ns-heading);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 18px;
}

.header-phone {
  color: var(--ns-muted);
  font-size: 13px;
  letter-spacing: 0.04em;
}

.header-cta {
  min-width: 112px;
  height: 40px;
  padding: 0 18px;
  font-size: 13px;
}

.menu-btn {
  width: 42px;
  height: 42px;
  padding: 0;
  border: 1px solid var(--ns-border);
  border-radius: 12px;
  background: transparent;
}

.menu-btn span {
  display: block;
  width: 18px;
  height: 1px;
  margin: 5px auto;
  background: var(--ns-heading);
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  padding: 8px 20px 20px;
  background: #fff;
  border-bottom: 1px solid var(--ns-border);
}

.mobile-nav a {
  padding: 12px 0;
  color: var(--ns-muted);
  border-bottom: 1px solid var(--ns-border);
}

.mobile-nav a.active,
.mobile-nav a:hover {
  color: var(--ns-cyan);
}

@media (max-width: 1100px) {
  .desktop-nav a {
    padding: 8px;
    font-size: 13px;
  }
}

@media (max-width: 1200px) {
  .header-phone {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue